import { encodeSeparator } from './encodeSeparator';

const cleanHtmlTags = (str: string): string => str.replace(/<[^>]+>/g, '');

export const queryCleaner = (str = ''): string =>
  encodeSeparator(cleanHtmlTags(str)).toLocaleLowerCase();
